import { render, staticRenderFns } from "./global-lookup.vue?vue&type=template&id=3fd46600"
import script from "./global-lookup.vue?vue&type=script&lang=js"
export * from "./global-lookup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports